<template>
  <div
    class="cx-slider__item -center"
    :style="{
      transition: silence ? undefined : `all ${timeBreak}s`,
      '-ms-transform': `translateX(${ translate }px)`,
      '-webkit-tranform': `translateX(${ translate }px)`,
      transform: `translateX(${ translate }px)`,
      backgroundColor: bg ? null : 'unset'
    }"
  >
    <slot
      :focusHandler="focusHandler"
      :blurHandler="blurHandler"
    ></slot>
  </div>
</template>

<script>
export default {
  name: 'cx-slider-item',
  props: {
    bg: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      selfIdx: 0,
      translate: 0,
      silence: false,
      active: false,
      childListeners: []
    }
  },
  mounted() {
    this.slideVnode && this.slideVnode.updateItems();
    this.childListeners = this.$children.filter(
      c => c.onSlideActive
        && typeof c.onSlideActive === "function"
        && c.onSlideDismiss
        && typeof c.onSlideDismiss === "function"
    )
  },
  computed: {
    slideVnode: function() {
      return this.$parent && this.$parent.$parent
    },
    timeBreak: function() {
      return (this.slideVnode && this.slideVnode.timeBreak || 300) / 1000;
    }
  },
  methods: {
    focusHandler() {
      if (this.slideVnode) {
        this.slideVnode.toSlide && this.slideVnode.toSlide(this.selfIdx || 1);
        this.slideVnode.focusHandler && this.slideVnode.focusHandler();
      }
    },
    blurHandler() {
      this.slideVnode
      && this.slideVnode.blurHandler
      && this.slideVnode.blurHandler();
    },
    updatePosition({
      idx,
      activeIdx,
      toRight = true,
      silence = false,
      cycling = false,
      offset = 0
    }) {
      this.selfIdx = idx + 1;
      if (!silence && activeIdx == idx + 1 && !this.active) {
        this.active = true;
        this.$emit('active');
        // pass the event to child
        this.childListeners.forEach(c => c.onSlideActive(this.slideVnode));
      } else if (!silence && this.active && activeIdx != idx + 1) {
        this.active = false;
        this.$emit('dismiss');
        // pass the event to child
        this.childListeners.forEach(c => c.onSlideDismiss(this.slideVnode));
      }

      this.silence = silence;
      offset = silence ? offset : 0;

      const parentWidth = parseFloat(getComputedStyle(this.slideVnode.$el).width.replace('px', ''), 10)
      const length = this.slideVnode.items.length;

      if (cycling) {
        let targetIdx = idx - activeIdx + 1;
        // console.log({targetIdx});

        if (targetIdx > length - 2) {
          let offset = length;
          if (targetIdx == length -1
            && ((silence && toRight) || (!silence && !toRight))
          ) {
              offset = 0;
          }

          targetIdx = targetIdx - offset;
        } else if (targetIdx < 0) {
          let offset = length;
          if (targetIdx == -1
            && ((!silence && toRight) || (silence && !toRight))
          ) {
              offset = 0;
          }

          targetIdx = targetIdx + offset;
        }

        this.translate = (targetIdx - idx) * parentWidth + offset;
        // console.log({
        //   idx, targetIdx, activeIdx, length, toRight, silence
        // });
      } else {
        this.translate = (1 - activeIdx) * parentWidth + offset;
      }
    }
  }
}
</script>
